export const USER_SETTINGS_QUERY_KEY = 'user-settings';
